import React from 'react'
import caymanislandsflag from '../assets/caymanislandsflag.png'
import barbadosflag from '../assets/barbadosflag.png'
import usaflag from '../assets/countries/united_state_flag.svg'
import canflag from '../assets/countries/canada_flag.svg'
import auflag from '../assets/countries/australia_flag.svg'
import gbflag from '../assets/countries/great_britain_flag.svg'
import nzflag from '../assets/countries/newzealand_flag.svg'
import {
  CountryContainer,
  FlagContainer,
  FlagRow,
} from '../components/ui/country-selection'
import {CancelOrderModal} from '../components/cancel-order-modal'
import {useUserRoles} from '../utils/use-user-roles'
import {useUserFeatures} from '../context/user-features-context'

const COUNTRIES = [
  {name: 'United States', value: 'usa', isoValue: 'US', img: usaflag},
  {name: 'Australia', value: 'aus', isoValue: 'AU', img: auflag},
  {
    name: 'Cayman Islands',
    value: 'cayman',
    isoValue: 'KY',
    img: caymanislandsflag,
  },
  {name: 'Barbados', value: 'barbados', isoValue: 'BB', img: barbadosflag},
  {name: 'Canada', value: 'can', isoValue: 'CA', img: canflag},
  {name: 'New Zealand', value: 'nz', isoValue: 'NZ', img: nzflag},
  {name: 'Great Britain', value: 'gb', isoValue: 'GB', img: gbflag},
]

const US_DEFAULT_ROLES = [
  'Premise',
  'PremisePilot',
  'PremiseDemo',
  'Admin',
  'DirectSales',
  'National',
  'InsideDemo',
  'Inbound LC',
  'LeadConverter',
  'KeapPartner',
  'PartnerOps',
  'Reseller',
]
const AU_DEFAULT_ROLES = ['Inside', 'Australia']
const NZ_DEFAULT_ROLES = ['NZSales']

function CountryFlag({img, countryName, isoValue, value, nextStep}) {
  return (
    <FlagContainer
      data-testid={isoValue}
      onClick={() => {
        nextStep({selectedCountry: {isoValue, value}})
      }}
    >
      <img src={img} alt={countryName} />
      <label className="text-center">{countryName}</label>
    </FlagContainer>
  )
}

function CountrySelection({nextStep}) {
  const {roles} = useUserRoles()
  const {Enable_GB_Loc_Access} = useUserFeatures()

  const canUSAAUUser = roles.some(role => ['PartnerOps'].includes(role))
  const canUSAOnlyUser = roles.some(role => [].includes(role))
  const canUSAUser = roles.some(role =>
    ['InsideDemo', 'PremiseDemo', 'Premise', 'National', 'reseller'].includes(
      role,
    ),
  )
  const canAUUser = roles.some(role => ['Inside'].includes(role))
  const skipCountrySelection = roles.some(role =>
    ['VivialDemo', 'ThryvOnly'].includes(role),
  )
  const defaultUSCountry = roles.some(role => US_DEFAULT_ROLES.includes(role))
  const defaultAUCountry =
    !defaultUSCountry && roles.some(role => AU_DEFAULT_ROLES.includes(role))
  const defaultNZCountry =
    !defaultUSCountry &&
    !defaultAUCountry &&
    roles.some(role => NZ_DEFAULT_ROLES.includes(role))

  const countriesToShow = (
    canUSAAUUser
      ? COUNTRIES.filter(
          country =>
            country.name === 'United States' ||
            country.name === 'Canada' ||
            country.name === 'Australia' ||
            country.name === 'New Zealand' ||
            country.name === 'Great Britain',
        )
      : canUSAUser
      ? COUNTRIES.filter(
          country =>
            country.name === 'United States' || country.name === 'Canada',
        )
      : canAUUser
      ? COUNTRIES.filter(
          country =>
            country.name === 'Australia' || country.name === 'New Zealand',
        )
      : canUSAOnlyUser
      ? COUNTRIES.filter(country => country.name === 'United States')
      : COUNTRIES
  ).filter(country => country.name !== 'Great Britain' || Enable_GB_Loc_Access)

  React.useEffect(() => {
    if (skipCountrySelection || defaultUSCountry) {
      nextStep({selectedCountry: {isoValue: 'US', value: 'usa'}})
    } else if (defaultAUCountry) {
      nextStep({selectedCountry: {isoValue: 'AU', value: 'aus'}})
    } else if (defaultNZCountry) {
      nextStep({selectedCountry: {isoValue: 'NZ', value: 'nz'}})
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CountryContainer>
      <h2 className="mt-5 mb-3">Where are you selling Thryv?</h2>
      <FlagRow>
        {countriesToShow.map(({name, img, isoValue, value}, i) => (
          <CountryFlag
            key={i}
            className="flag"
            img={img}
            countryName={name}
            isoValue={isoValue}
            value={value}
            nextStep={nextStep}
          />
        ))}
      </FlagRow>
      <div className="d-flex justify-content-center">
        <CancelOrderModal cancelUrl="/accounts/my-accounts" />
      </div>
    </CountryContainer>
  )
}

export {CountrySelection}
